<pr-input-abstract
  [control]="control"
  [label]="label"
  [derrors]="derrors"
  [highlightOnValue]="highlightOnValue"
  class="pr-input-autosuggest"
  [isDefault]="isDefault"
  [loading]="loading"
>
  <input
    type="text"
    matInput
    #input
    [formControl]="control"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
  >
    @for (option of filteredOptionsFavorite; track option) {
      <mat-option [value]="option">
        {{ option[optionLabel] }}
        @if (additionalOptionLabel) {
          @for (label of additionalOptionLabel; track label) {
            <span>({{ getAdditionalOptionLabel(option, label) }})</span>
            <span class="option-label-space"></span>
          }
        }
        @if (optionIcon(option)) {
          <pr-icon name="{{ optionIcon(option)?.join(' ') }}"></pr-icon>
        }
      </mat-option>
    }
    <mat-divider></mat-divider>

    @for (option of $filteredOptions | async; track option) {
      <mat-option [value]="option">
        {{ option[optionLabel] }}
        @if (additionalOptionLabel) {
          @for (label of additionalOptionLabel; track label) {
            @if (label.useParentheses) {
              <span> ({{ getAdditionalOptionLabel(option, label.name) }})</span>
            }
            @if (label.useDash) {
              <span> - {{ getAdditionalOptionLabel(option, label.name) }}</span>
            }
            <span class="option-label-space"></span>
          }
        }
        @if (optionIcon(option)) {
          <pr-icon name="{{ optionIcon(option)?.join(' ') }}"></pr-icon>
        }
      </mat-option>
    }
    @if (showAddButton) {
      @if (onCreateOption) {
        <mat-option class="mat-option-add" (click)="handleCreate($event)" [value]="control.value">
          @if (creating) {
            <span>Création en cours...</span>
          } @else {
            <span>Créer « {{ input.value }} »</span>
          }
        </mat-option>
      } @else {
        <mat-option class="mat-option-add" [value]="control.value">
          <div #customOptionText [hidden]="noCustom">
            <ng-content select="[customOptionText]"></ng-content>
          </div>
          @if (customOptionText.children.length == 0) {
            <span [hidden]="noCustom">Créé lors de l'enregistrement.</span>
          }
        </mat-option>
      }
    }
  </mat-autocomplete>
  <pr-icon name="search"></pr-icon>
</pr-input-abstract>
